<script>
import { mergeData } from 'vue-functional-data-merge';
const VEntry = () => import('./Entry');
const VButton = () => import('@/components/Button');

export default {
  name: 'DescriptionListEntryButton',

  functional: true,

  props: {
    name: {
      type: [Number, String],
      required: false,
      default: null,
    },

    label: {
      type: [Number, String],
      required: false,
      default: null,
    },

    to: {
      type: [String, Object],
      required: false,
      default: null,
    },

    hidden: {
      type: Boolean,
      required: false,
    },
  },

  render(h, { props, data, children, parent, listeners }) {
    const componentData = {
      scopedSlots: {},
    };

    componentData.scopedSlots.name = () => {
      let name;
      if (data.scopedSlots?.name) {
        name = data.scopedSlots.name();
      } else {
        name = h('span', { domProps: { innerHTML: parent.$to(props.name) } });
      }

      let buttonChildren = null;
      if (data.scopedSlots?.label) {
        buttonChildren = [data.scopedSlots.label()];
      }

      let button;
      if (!props.hidden && (props.label || buttonChildren || data.scopedSlots?.button)) {
        if (data.scopedSlots?.button) {
          button = data.scopedSlots.button();
        } else {
          button = h(
            VButton,
            {
              on: listeners,
              attrs: data.attrs,
              staticClass: `btn-default btn-small pull-right ${data.staticClass}`,
              class: data.class,
              props: {
                label: props.label,
                to: props.to,
              },
            },
            buttonChildren
          );
        }
      }
      return [button, name];
    };

    return h(VEntry, mergeData(data, componentData), children);
  },
};
</script>
